import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Tab, Tabs } from '@mui/material';
import { OLD_VOICE_LIBRARY, VOICE_LIBRARY } from '@src/constants/voice';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import actions from '@src/redux/actions';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { COLOR } from '@src/styles/color';
import { StyledVoiceFilter } from './index.styled';

const VoiceFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { filterVoice } = useSelector((state) => state.voice);
  const { getFeatureValue } = useFeatureFlags();
  const { user } = useSelector((state) => state.auth);
  const voiceOwnershipFilter = filterVoice?.voiceOwnership;

  const usePublicVoiceCloning = getFeatureValue(
    FEATURE_KEYS.USE_PUBLIC_VOICE_CLONING,
    { userId: user?.id },
  );

  const handleChangeVoiceOwnership = (_, value) =>
    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        voiceOwnership: value,
      }),
    );

  return (
    <StyledVoiceFilter voiceFilterV2={usePublicVoiceCloning}>
      {!usePublicVoiceCloning &&
        OLD_VOICE_LIBRARY.map((item) => (
          <Button
            fullWidth
            className={`filter-button ${
              voiceOwnershipFilter === item.value ? 'active-button' : ''
            }`}
            onClick={() => handleChangeVoiceOwnership('', item.value)}
            key={item.value}
          >
            {t(item.label)}
          </Button>
        ))}

      {usePublicVoiceCloning && (
        <Tabs
          value={voiceOwnershipFilter}
          onChange={handleChangeVoiceOwnership}
          // variant="fullWidth"
          indicatorColor={COLOR.darkBlue}
          textColor={COLOR.darkBlue}
        >
          {VOICE_LIBRARY.map((item) => (
            <Tab
              key={item.value}
              value={item.value}
              label={t(item.label)}
              className="filter-tab"
            />
          ))}
        </Tabs>
      )}
    </StyledVoiceFilter>
  );
};

export default VoiceFilter;
